import { render, staticRenderFns } from "./TranscriptModal.vue?vue&type=template&id=320fa870"
import script from "./TranscriptModal.vue?vue&type=script&lang=js"
export * from "./TranscriptModal.vue?vue&type=script&lang=js"
import style0 from "./TranscriptModal.vue?vue&type=style&index=0&id=320fa870&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports